import React from "react";
import { MdCheckCircle, MdCancel, MdAccessTime } from "react-icons/md";
import { productAttributesStatusText } from "../../utils";

const ProductTopupPackages = ({
  product,
  selectedTopUpPackage,
  setSelectedTopUpPackage,
}) => {
  if (product?.product_type !== "topup_package") {
    return null;
  }

  return (
    <section className="pdp-packages-card">
      <h3 className="pdp-packages-title">Chọn gói nạp</h3>

      <div className="pdp-packages-grid">
        {product?.product_attributes?.packages?.map((pack) => (
          <TopupPackageCard
            key={pack?._id}
            pack={pack}
            isSelected={selectedTopUpPackage?._id === pack?._id}
            onSelect={setSelectedTopUpPackage}
          />
        ))}
      </div>
    </section>
  );
};

const TopupPackageCard = ({ pack, isSelected, onSelect }) => {
  const isAvailable = pack?.status === "available";
  const statusMeta = getPackageStatusMeta(pack?.status);

  const handleSelect = () => {
    if (!isAvailable) return;
    onSelect(pack);
  };

  return (
    <article
      className={`pdp-package-item ${isSelected ? "pdp-package-item--active" : ""} ${
        !isAvailable ? "pdp-package-item--disabled" : ""
      }`}
      onClick={handleSelect}
    >
      <img
        className="pdp-package-item-image"
        alt="Top Up Package"
        src={
          pack?.img ||
          "https://img.redbull.com/images/c_fill,g_auto,w_450,h_600/q_auto:low,f_auto/redbullcom/2016/05/10/1331793850853_2/clash-royale-trucchi-e-consigli-1"
        }
      />

      <div className="pdp-package-item-content">
        <p className="pdp-package-item-name">{pack?.name}</p>

        <div className="pdp-package-item-footer">
          <div className={`pdp-package-item-status pdp-package-item-status--${statusMeta.className}`}>
            <statusMeta.Icon className="pdp-package-item-status-icon" />
            <p className="pdp-package-item-status-text">
              {productAttributesStatusText(pack?.status)}
            </p>
          </div>

          <p className="pdp-package-item-price">{(pack?.price || 0).toLocaleString()}đ</p>
        </div>
      </div>
    </article>
  );
};

const getPackageStatusMeta = (status) => {
  switch (status) {
    case "available":
    case "active":
      return { Icon: MdCheckCircle, className: "available" };
    case "unavailable":
      return { Icon: MdCancel, className: "unavailable" };
    case "order":
      return { Icon: MdAccessTime, className: "order" };
    default:
      return { Icon: MdAccessTime, className: "default" };
  }
};

export default ProductTopupPackages;
